import React from 'react';
import { GenericEdited } from '@dbk/ui-icons';
import { TouchableOpacity } from 'react-native';
import { View } from '@dbk/ui-react-utils';
import { Checkbox } from '@dbk/ui-forms';
import { NavigationListItemHeader } from '@dbk/ui-list';
import { Large } from '@dbk/ui-text';
import { PALETTE } from '../../../constants';

const ReportRMListHeader = ((props) => (
  <View style={{ width: "100%", height: "100%", paddingTop: 4, paddingBottom: 4, marginLeft: 5 }}>
    <NavigationListItemHeader>
      <Checkbox
        className="checkboxClass"
        checked={props.isChecked}
        onChange={props.handleCategoryClick}
        label={<Large numberOfLines={2} ellipsizeMode={'tail'}
          className="rowHeader" style={props.isRead ? { color: PALETTE.secondaryText } :  { color: PALETTE.primaryActive }}
          testID="textbox_report_reportRMListHeader_test">
          {props.categoryName}
        </Large>}
        testID="checkbox_report_reportRMListHeader_test"
      />
      <View  >
        <TouchableOpacity onPress={() => props.pdfClick()}>
          <GenericEdited color={PALETTE.primaryTextDisabled}
            height={34}
            width={34}
          />
        </TouchableOpacity>
      </View>
    </NavigationListItemHeader>
    <View style={{ display: "flex", justifyContent: "space-between" }} >
      <View id="text_report_reportRMListHeader_test"
        secondary className="rowFooter" style={{ color: '#a7a8aa', fontSize: "14px" }}>
        {props.receivedDate}
      </View>
    </View>
  </View>
));

export default ReportRMListHeader;
